import { WritableDraft } from "immer";
import assign from "lodash/assign";
import omitBy from "lodash/omitBy";
import { FiltersV2StoreType } from "PFApp/components/filters_v2/stores/filters_v2_store/filters_v2_store.types";
import * as mutators from "PFApp/components/filters_v2/stores/filters_v2_store/mutators/index";
import { validateAndEmitFiltersUpdate } from "PFApp/components/filters_v2/stores/filters_v2_store/mutators/index";
import { getFiltersWithDifferentValues } from "PFCore/helpers/filters";

export const applyBuffer = (draftState: WritableDraft<FiltersV2StoreType>) => {
  const updatedMainFiltersWithValidState = omitBy(draftState.buffer.mainFilters, "error");
  const updatedChildrenFiltersWithValidState = omitBy(draftState.buffer.childrenFilters, "error");

  const updatedMainFilters = getFiltersWithDifferentValues(
    updatedMainFiltersWithValidState,
    draftState.mainFilters
  );

  const updatedChildrenFilters = getFiltersWithDifferentValues(
    updatedChildrenFiltersWithValidState,
    draftState.childrenFilters
  );

  const updatedFilters = [...updatedMainFilters, ...updatedChildrenFilters];

  assign(draftState.mainFilters, updatedMainFiltersWithValidState);
  assign(draftState.childrenFilters, updatedChildrenFiltersWithValidState);
  draftState.areChildrenOn = draftState.buffer.areChildrenOn;

  return updatedFilters;
};

export const resetBuffer = (draftState: WritableDraft<FiltersV2StoreType>) => {
  draftState.buffer.mainFilters = draftState.mainFilters;
  draftState.buffer.childrenFilters = draftState.childrenFilters;
  draftState.buffer.areChildrenOn = draftState.areChildrenOn;
};

export const autoRefreshFilters = (draftState: WritableDraft<FiltersV2StoreType>) => {
  if (draftState.isAutoRefreshOn) {
    const updatedFilters = mutators.applyBuffer(draftState);
    validateAndEmitFiltersUpdate(draftState, updatedFilters);
  }
};
